import React, { useEffect, useRef } from 'react'
import { Link } from 'react-router-dom'
import classNames from 'classnames'

interface TrustpilotCollectProps {
  templateID: string
  businessUnitID: string
  width: string
  height: string
}

export default function TrustpilotCollect({
  templateID,
  businessUnitID,
  width,
  height,
}: TrustpilotCollectProps): React.ReactElement | null {
  const ref = useRef(null)

  useEffect(() => {
    // If window.Trustpilot is available it means that we need to load the TrustBox from our ref.
    // If it's not, it means the script you pasted into <head /> isn't loaded  just yet.
    // When it is, it will automatically load the TrustBox.
    if (window.Trustpilot) {
      window.Trustpilot.loadFromElement(ref.current, true)
    }
  }, [])

  const trustpilotClasses = classNames('trustpilot-widget')

  return (
    <div
      ref={ref}
      className={trustpilotClasses}
      data-locale="en-GB"
      data-template-id={templateID}
      data-businessunit-id={businessUnitID}
      data-style-height={height}
      data-style-width={width}
    >
      <Link
        to={{ pathname: 'https://uk.trustpilot.com/review/uplifter.ai' }}
        target="_blank"
      >
        Trustpilot
      </Link>
    </div>
  )
}
